module.exports = __webpack_public_path__ + "static/media/eduardo_clemente_de_medeiros.9955b3c1.jpg";